import request from '@/libs/http/index'

//添加购物车
export function shoppingCarPost(data) {
  return request.post(`pc/shoppingCar`, data)
}

//购物车列表
export function shoppingCarList() {
  return request.get(`pc/shoppingCar/list`)
}

//修改商品数量
export function editGoodsQuantity(data) {
  return request.put(`pc/shoppingCar/editGoodsQuantity`, data)
}

//选中商品
export function selected(ids) {
  return request.put(`pc/shoppingCar/selected/${ids}`)
}

//删除商品
export function shoppingCaDelete(ids) {
  return request.delete(`pc/shoppingCar/${ids}`)
}

//立即下单
export function OrderNow(data) {
  return request.post(`pc/shoppingCar/order`, data)
}
